
    import { applyTheme, getStoredTheme } from "./index/theme.ts";
    applyTheme(getStoredTheme());
    await import("./index/index.ts");
  